// Imports
import Swup from 'swup';
import SwupScrollPlugin from '@swup/scroll-plugin';

import Alpine from 'alpinejs';
import intersect from '@alpinejs/intersect';
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import { Pagination } from 'swiper/modules';
import { Scrollbar } from 'swiper/modules';
import collapse from '@alpinejs/collapse';
import { Autoplay } from 'swiper/modules';

import Splide from '@splidejs/splide';
const isMobile = window.matchMedia("only screen and (max-width: 480px)").matches;

// Swup Initialization
const swup = new Swup({
  plugins: [
    new SwupScrollPlugin()
  ]
});


// Swup Hooks
swup.hooks.on('page:view', (visit) => {
  console.log('New page loaded:', visit.to.url);
  init();
  updateBackground();
});
swup.hooks.on('content:replace', () => {
  console.log('content replaced');

  // Alpine.discoverUninitializedComponents((el) => {
  //   Alpine.initializeComponent(el);
  //   console.log('alpine initialized');
  // });

});


Alpine.plugin(intersect);

Alpine.plugin(collapse)

Swiper.use([Navigation, Pagination, Scrollbar, Autoplay]);

function loadSwiper() {
  console.log('loadSwiper');
  if (document.querySelector('.swiper')) {
    const swiper = new Swiper('.swiper', {
      autoplay: {
        delay: 5000,
      },
      modules: [Scrollbar, Navigation, Pagination],
      loop: true,
      pagination: {
        el: '.swiper-pagination',
      },

      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      scrollbar: {
        el: '.swiper-scrollbar',
      },

    });
  }
}


function updateBackground() {
  const background = document.querySelector('main')?.getAttribute('data-background');
  document.querySelector('.header')?.classList.toggle('header--white', background === '#ffffff');
}


// AlpineJS Initialization
window.Alpine = Alpine;
Alpine.start();

////////////////////////////// Init Functions /////////////////////////////////////

// Functions 
function l(m) {
  console.log(m);
}


document.addEventListener("DOMContentLoaded", () => {
  l('ready');
  init();
});


function init() {
  // Basic setup and utilities
  l('👍');
  slider();
  loadSwiper();
}

// function startSliders() {
//   if(document.querySelectorAll('.splide').length) { 
//     let perPage = isMobile ? 1.5 : 3.5;
//     let splide = new Splide( '.splide', {
//       type: 'loop',
//       focus  : 'left',
//       perPage: perPage,
//       arrows: true,
//       pagination: false
//     });

//     splide.mount();
//   }

// }

window.onbeforeunload = function () {
  // smoothScrollToTop(500);
}

window.addEventListener('resize', () => {
  ;
});

window.addEventListener('scroll', () => {
});

// document.addEventListener('click', function (event) {
//   l('clicked');
// });

function slider() {
  // Check if the .slider element exists
  if (!document.querySelector('.slider')) return;

  var slides = document.querySelectorAll('.slider_item');
  var paginationDots = document.querySelectorAll('.slider_pagination .slider_index');
  var currentSlide = 0;
  var rotationAngle = 0;
  var sliderImage = document.querySelector('.slider_image img');
  var interval;


  if (sliderImage) {
    sliderImage.style.transform = 'rotate(0deg)';
  }

  function startSlider() {
    interval = setInterval(function () {
      // Remove active class from all slides and pagination dots
      slides.forEach(function (slide) {
        slide.classList.remove('active');
      });
      paginationDots.forEach(function (dot) {
        dot.classList.remove('active');
      });

      // Update slide
      currentSlide = (currentSlide + 1) % slides.length;
      slides[currentSlide].classList.add('active');
      paginationDots[currentSlide].classList.add('active');

      // Rotate image
      rotationAngle += 90;
      if (sliderImage) {
        sliderImage.style.transform = 'rotate(' + rotationAngle + 'deg)';
      }
    }, 5000);
  }

  function stopSlider() {
    clearInterval(interval);
  }

  // Listen for visibility change events
  document.addEventListener('visibilitychange', function () {
    console.log('changed');
    if (document.visibilityState === 'visible') {
      startSlider();
    } else {
      stopSlider();
    }
  });

  // Start the slider initially
  startSlider();
}
